/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: eca5fc74daf0
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  StreamingProfileDataResponse,
  StreamingProfileDataResponse$zodSchema,
} from "./streamingprofiledataresponse.js";

export type GetStreamingProfileGlobals = { cloud_name?: string | undefined };

export const GetStreamingProfileGlobals$zodSchema: z.ZodType<
  GetStreamingProfileGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type GetStreamingProfileRequest = { name: string };

export const GetStreamingProfileRequest$zodSchema: z.ZodType<
  GetStreamingProfileRequest
> = z.object({
  name: z.string().describe("The name of the streaming profile."),
});

export type GetStreamingProfileResponse =
  | StreamingProfileDataResponse
  | ApiError;

export const GetStreamingProfileResponse$zodSchema: z.ZodType<
  GetStreamingProfileResponse
> = z.union([
  StreamingProfileDataResponse$zodSchema,
  ApiError$zodSchema,
]);
